import { useContext, useEffect } from "react";
import AuthContext from "../../context/autenticacion/authContext.js";
import { FC_targetas } from "views/Tagetas/functions.js";
import { useT } from "i18n";


const DetailsCardModal = ({ data, onClose }) => {
  const { t, ts } = useT();

  const regex = /^-/
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    return `${day}/${month}/${year}`;
  }

  const formatDateTarjeta = (dateString) => {
    const monthsInSpanish = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((n) => t('tarjeta.mes' + n));
  
    const date = new Date(dateString);
    const day = date.getUTCDate();
    const month = monthsInSpanish[date.getUTCMonth()];
    const year = date.getUTCFullYear();
    return `${day} ${month}, ${year}`;
  }

  function limitString(str, maxLength) {
    if (str.length <= maxLength) {
      return str;
    }
    return str.slice(0, maxLength); // Adding ellipsis to indicate truncation
  }
  

  const authContext = useContext(AuthContext);

  const { PantherNoLoad, PantherLoad, panther_load, recargandoapp } =
    authContext;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [panther_load]);

  return (
    <>
      <div className="row w-100 m-auto">
        <div className="d-flex justify-content-between w-100 border-bottom-2 border-white px-3 align-items-center">
          <div className="mb-auto">
            <h2 className="">{t("tarjeta.detalles")}</h2>
          </div>
          <div className="mb-auto btn-back-tarjetas">
            <i 
              onClick={onClose} 
              className="tim-icons icon-simple-remove"  
            />
          </div>
        </div>
        <div className="col-12 col-md-6">
          <p className="d-flex justify-content-between align-items-center border-bottom">
            <span className="">{t("tarjeta.dBloqueado")} </span>
            <span className="value-description">{data.blocked_balance ? data.blocked_balance : '0.00'} USDT</span>
          </p>
          <p className="d-flex justify-content-between align-items-center border-bottom">
            <span>{t("tarjeta.dTransito")}</span> 
            <span className="value-description">{!data.transit_balance ? '0.00' : data.transit_balance} USDT</span>
          </p>
          <p className="d-flex justify-content-between align-items-center border-bottom">
            <span>{t("tarjeta.dNumero")}{" "}</span>
            <span className="value-description">{!data.number ? "0000-0000-0000-0000" : FC_targetas.formatCardNumber(data.number)}</span>
          </p>
          <p className="d-flex justify-content-between align-items-center border-bottom py-3">
            <span>{t("tarjeta.dEstatus")} </span>
            <span
              className={`${
                data.status !== "APROBADO" ? "saldos-neg" : "saldos-plus"
              } `}
            >
              {" "}
              {ts(data.status)}
            </span>{" "}
          </p>
          <p className="d-flex justify-content-between align-items-center border-bottom">
            <span>{t("tarjeta.dCreado")}{" "}</span>
            <span className="value-description"> {!data.created_at ? "00/00/0000" : formatDate(data.created_at)} </span>
          </p>
          <p className="d-flex justify-content-between align-items-center border-bottom">
            <span>{t("tarjeta.dActualizado")}{" "}</span>
            <span className="value-description">{!data.created_at ? "00/00/0000" : formatDate(data.updated_at)}</span>
          </p>
        </div>

        <div className="col-12 col-md-6">
          <h2 className="title w-100 border-bottom">{t("tarjeta.dTransacciones")}</h2>
          <ul className="list-group custom-scroll-tarjetas">
            {
              data.movimientos.length > 0 
              ?
              data.movimientos.map((item) => {
                return (
                  <li className="list-item mb-2" key={item.id}>
                    <div className="w-100">
                      <div className="d-flex justify-content-between border-bottom transaction-history-tarjetas">
                        <div className="">
                          <div className="d-flex justify-content-center">
                            <span className="mr-1">{!item?.description ? '--------' : limitString(item?.description, 12) + "..."}</span>{' | '} 
                            <span className="ml-1">{!data.number ? limitString("0000-0000-0000-0000", 9) : limitString(FC_targetas.formatCardNumber(data.number), 9)}</span>
                          </div>
                          <p>{t("tarjeta.dReferencia")} {!item?.reference ? "--------" : item?.reference}</p>
                          <p>{t("tarjeta.dCreadoPor")} {!item?.created_by ? t("tarjeta.dNinguno") : item?.created_by}</p>
                        </div>

                        <div className="">
                          <p className="">{!item?.amount ? "0.00" : <span className={regex.test(item.amount) ? "text-danger fw-bold amount-value-tarjeta" : "text-success fw-bold amount-value-tarjeta"}>{item?.amount}</span>} USDT</p>
                          <p className="ml-4 mr-0 my-0 date-value-tarjeta">{!item?.created_at ? "0000/00/00" : formatDateTarjeta(item?.created_at)}</p>
                        </div>
                      </div>

                    </div>
                  </li>
                );
              })
              : (
                <li className="list-item">
                    <div className="">
                      <p>{t("tarjeta.dDescripcion")} --------</p>
                      <p>{t("tarjeta.dCantidad")} <span>0.00</span> USDT</p>
                      <p>{t("tarjeta.dCreadoPor")} <span>{t("tarjeta.dNone")}</span></p>
                      <p>{t("tarjeta.dReferencia")} <span>--------</span></p>
                      <p>{t("tarjeta.dCreado")} <span>0000/00/00</span></p>
                    </div>
                  </li>
              )

            }
          </ul>
        </div>
      </div>
      
    </>
  );
};

export default DetailsCardModal;
